import {atom} from 'jotai';

export const pendingEmailState = atom(false);
